import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CreateDeviceDto {
  ipAddress: string;
  friendlyName: string;
  description?: string;
  location?: string;
  isActive: boolean;
}

export interface UpdateDeviceDto {
  id: number;
  ipAddress: string;
  friendlyName: string;
  description?: string;
  location?: string;
  isActive: boolean;
}

export interface DeviceResponseDto {
  id: number;
  ipAddress: string;
  friendlyName: string;
  description?: string;
  location?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface GetDevicesQueryResponse {
  devices: DeviceResponseDto[];
}

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  getDevices(): Observable<GetDevicesQueryResponse> {
    return this.http.get<GetDevicesQueryResponse>(`${this.baseUrl}/api/Device`);
  }

  getDevice(id: number): Observable<DeviceResponseDto> {
    return this.http.get<DeviceResponseDto>(`${this.baseUrl}/api/Device/${id}`);
  }

  createDevice(device: CreateDeviceDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Device`, device);
  }

  updateDevice(device: UpdateDeviceDto): Observable<any> {
    return this.http.put(`${this.baseUrl}/api/Device/${device.id}`, device);
  }

  deleteDevice(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/api/Device/${id}`);
  }

  resolveDevice(ipAddress: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/Device/resolve/${ipAddress}`);
  }
} 